
export enum ExternalPackageMethod {
  Implementation = 'implementation',
  API = 'api'
}

export type ExternalPackage = {
  method: ExternalPackageMethod;
  package: string;
};

export function externalPackageToLocal(res: any): ExternalPackage {

  return {
    method: res.method,
    package: res.package
  };
}

export function externalPackageToServer(data: ExternalPackage): any {
  const payload: any = {
    method: data.method,
    package: data.package
  };
  return payload;
}
